export const FETCH_TYPE_FIELD_REQUEST = "FETCH_TYPE_FIELD_REQUEST";
export const FETCH_TYPE_FIELD_SUCCESS = "FETCH_TYPE_FIELD_SUCCESS";
export const FETCH_TYPE_FIELD_FAIL = "FETCH_TYPE_FIELD_FAIL";

export const FETCH_TYPE_FIELD_BY_LIST_NAME_REQUEST = "FETCH_TYPE_FIELD_BY_LIST_NAME_REQUEST";
export const FETCH_TYPE_FIELD_BY_LIST_NAME_SUCCESS = "FETCH_TYPE_FIELD_BY_LIST_NAME_SUCCESS";
export const FETCH_TYPE_FIELD_BY_LIST_NAME_FAIL = "FETCH_TYPE_FIELD_BY_LIST_NAME_FAIL";

export const CREATE_TYPE_FIELD_REQUEST = "CREATE_TYPE_FIELD_REQUEST";
export const CREATE_TYPE_FIELD_SUCCESS = "CREATE_TYPE_FIELD_SUCCESS";
export const CREATE_TYPE_FIELD_FAIL = "CREATE_TYPE_FIELD_FAIL";

export const UPDATE_TYPE_FIELD_REQUEST = "UPDATE_TYPE_FIELD_REQUEST";
export const UPDATE_TYPE_FIELD_SUCCESS = "UPDATE_TYPE_FIELD_SUCCESS";
export const UPDATE_TYPE_FIELD_FAIL = "UPDATE_TYPE_FIELD_FAIL";

export const SHOW_TYPE_FIELD_REQUEST = "SHOW_TYPE_FIELD_REQUEST";
export const SHOW_TYPE_FIELD_SUCCESS = "SHOW_TYPE_FIELD_SUCCESS";
export const SHOW_TYPE_FIELD_FAIL = "SHOW_TYPE_FIELD_FAIL";

export const FETCH_TYPE_FIELD_VALUE_REQUEST = "FETCH_TYPE_FIELD_VALUE_REQUEST";
export const FETCH_TYPE_FIELD_VALUE_SUCCESS = "FETCH_TYPE_FIELD_VALUE_SUCCESS";
export const FETCH_TYPE_FIELD_VALUE_FAIL = "FETCH_TYPE_FIELD_VALUE_FAIL";

export const CREATE_TYPE_FIELD_VALUE_REQUEST =
  "CREATE_TYPE_FIELD_VALUE_REQUEST";
export const CREATE_TYPE_FIELD_VALUE_SUCCESS =
  "CREATE_TYPE_FIELD_VALUE_SUCCESS";
export const CREATE_TYPE_FIELD_VALUE_FAIL = "CREATE_TYPE_FIELD_VALUE_FAIL";

export const UPDATE_TYPE_FIELD_VALUE_REQUEST =
  "UPDATE_TYPE_FIELD_VALUE_REQUEST";
export const UPDATE_TYPE_FIELD_VALUE_SUCCESS =
  "UPDATE_TYPE_FIELD_VALUE_SUCCESS";
export const UPDATE_TYPE_FIELD_VALUE_FAIL = "UPDATE_TYPE_FIELD_VALUE_FAIL";

export const SHOW_TYPE_FIELD_VALUE_REQUEST = "SHOW_TYPE_FIELD_VALUE_REQUEST";
export const SHOW_TYPE_FIELD_VALUE_SUCCESS = "SHOW_TYPE_FIELD_VALUE_SUCCESS";
export const SHOW_TYPE_FIELD_VALUE_FAIL = "SHOW_TYPE_FIELD_VALUE_FAIL";
